import React, { useState } from "react";
import { MapPin, PencilSimple } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";

const KEY = "ppc_city";

export const readCity = () => localStorage.getItem(KEY) || "";

export const LocationPicker = ({ value, onChange }) => {
  const { t } = useLang();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || "");

  const save = () => {
    const next = draft.trim();
    localStorage.setItem(KEY, next);
    onChange(next);
    setEditing(false);
  };

  return (
    <div className="loc-row" data-testid="location-picker">
      <span className="loc-dot">
        <MapPin size={18} weight="fill" color="#c6bff0" />
      </span>
      <div className="min-w-0">
        <p className="label-caps">{t("filter_city")}</p>
        {editing ? (
          <input
            autoFocus
            data-testid="location-input"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={save}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                save();
              }
            }}
            placeholder={t("filter_city")}
            className="w-full max-w-[180px] bg-transparent text-[15px] text-ppc-text outline-none placeholder:text-ppc-muted"
          />
        ) : (
          <button
            type="button"
            data-testid="location-edit-btn"
            onClick={() => {
              setDraft(value || "");
              setEditing(true);
            }}
            className="flex items-center gap-1.5 text-[15px] text-ppc-text"
          >
            <span className="max-w-[180px] truncate">{value || t("filter_all")}</span>
            <PencilSimple size={13} color="#c6bff0" />
          </button>
        )}
      </div>
    </div>
  );
};
